export default __webpack_public_path__ + "static/media/part-1.b1600808.jpg";